import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Toggler.module.css';

const bindClasses = classNameBind.bind(styles);

export default class Toggler extends React.Component {
  static defaultProps = {
    disabled: false,
    onChange: () => {},
    appearance: 'default',
  }

  handleChange = () => {
    const {
      disabled,
      onChange,
      value,
      name,
    } = this.props;

    if (!disabled) {
      onChange({
        target: {
          name,
          value: !value,
        },
      });
    }
  }

  render() {
    const {
      id,
      disabled,
      value,
      name,
      appearance,
    } = this.props;

    return (
      <div
        className={bindClasses('wrapper', { disabled })}
        data-ppuc-id="Toggler"
        onClick={this.handleChange}
        role="button"
        tabIndex={-1}
      >
        <input
          id={id}
          type="checkbox"
          name={name}
          disabled={disabled}
          value={value}
          tabIndex={0}
          className={bindClasses('toggler-checkbox')}
          data-ppuc-id="Toggler.value"
        />
        <div
          className={bindClasses('background', appearance, { checked: value })}
        >
          <div className={bindClasses('switch', appearance, { disabled })} />
        </div>
      </div>
    );
  }
}
